import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthInterceptor } from "./authInterceptor";
import { ErrorCatchingInterceptor } from "./errorInterceptor";
import { LoadingInterceptor } from "./loading.interceptor";
import { SubdomainInterceptor } from "../subdomain.interceptor";

export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor , multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: ErrorCatchingInterceptor , multi: true},    
    { provide: HTTP_INTERCEPTORS, useClass: SubdomainInterceptor , multi: true},    
]